import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define a type for the slice state
export interface ConfigState {

}

const initialState: ConfigState = {
   
}

export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        // setApiClientConfiguration: (state, action: PayloadAction<SpotlightAPIClientConfig>) => {
        //     state.apiClientConfig = action.payload
        // },
        // /** Set the required sdk config settings for UI/api requests */
        // setConfiguration: (state, action: PayloadAction<InitializationConfig>) => {
        //     const config = action.payload
        //     state.apiClientConfig = {
        //         apiKey: 'dev',
        //         basePath: action.payload.baseApiUrl,
        //         clientId: action.payload.clientId,
        //         profileId: action.payload.user.profileId
        //     }
        //     state.baseApiUrl = config.baseApiUrl
        //     state.baseAppUrl = config.baseAppUrl
        //     state.clientId = config.clientId
        //     state.playlistId = config.playlistId ? config.playlistId : undefined
        //     state.settings = config.settings
        //     state.urlSlug = config.urlSlug
        //     state.configured = true
        //     state.features.useChat = action.payload.features.useChat
        //     state.theme = action.payload.theme
        // },
    }
})

export const {
    // setApiClientConfiguration,
    // setConfiguration
} = configSlice.actions

export default configSlice.reducer